import { IIconProps } from "@/components/icons/interface";

/**
 * HP Client Theme - Jobs Waiting for Approval Icon
 * Lucide clipboard-clock style for home KPI stats
 */
const JobsWaitingIcon = (props: IIconProps) => {
  const iconColor = props.color || "#92400E";
  const width = props.width ?? 24;
  const height = props.height ?? 24;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={iconColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M16 14v2.2l1.6 1" />
      <path d="M16 4h2a2 2 0 0 1 2 2v.832" />
      <path d="M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2" />
      <circle cx="16" cy="16" r="6" />
      <rect x="8" y="2" width="8" height="4" rx="1" />
    </svg>
  );
};

export { JobsWaitingIcon };
